// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import Logo from "@/components/Logo";

function googleSignIn() {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/app";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

function GoogleIcon() {
    return (
        <svg width="20" height="20" viewBox="0 0 48 48" aria-hidden="true">
            <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.6 6.5 29.6 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.4-.4-3.5z"/>
            <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8c1.8-4.4 6.1-7.5 11.1-7.5 3 0 5.8 1.1 7.9 3l5.7-5.7C34.6 6.5 29.6 4 24 4 16.3 4 9.6 8.4 6.3 14.7z"/>
            <path fill="#4CAF50" d="M24 44c5.5 0 10.4-2.1 14.1-5.5l-6.5-5.5c-2 1.4-4.5 2.2-7.6 2.2-5.2 0-9.6-3.3-11.2-7.9l-6.5 5C9.4 39.5 16 44 24 44z"/>
            <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.5l6.5 5.5c-.5.4 7.1-5.2 7.1-15 0-1.2-.1-2.4-.3-3.5z"/>
        </svg>
    );
}

export default function RegisterPage() {
    return (
        <div
            className="min-h-screen grid md:grid-cols-2 bg-sf-bg"
            data-testid="register-page"
        >
            <div className="flex items-center justify-center p-8 order-2 md:order-1">
                <div className="w-full max-w-sm">
                    <Logo className="h-32 w-auto mb-10 md:hidden" />
                    <div className="label-eyebrow mb-3">Inizia gratis</div>
                    <h1 className="font-display text-4xl text-navy mb-3">
                        Crea il tuo Staff Flow
                    </h1>
                    <p className="text-sf-secondary text-sm mb-10 leading-relaxed">
                        Registrati in un click con Google. Il tuo trial
                        gratuito si attiva subito (max 3 dipendenti).
                    </p>

                    <Button
                        type="button"
                        onClick={googleSignIn}
                        className="w-full bg-white border-2 border-sf hover:border-navy text-navy lift py-6 text-base font-semibold"
                        data-testid="register-google-btn"
                    >
                        <GoogleIcon />
                        <span className="ml-3">Registrati con Google</span>
                    </Button>

                    <div className="mt-6 text-sm text-sf-secondary text-center">
                        Hai già un account?{" "}
                        <Link
                            to="/login"
                            className="text-navy font-semibold underline"
                            data-testid="register-to-login"
                        >
                            Accedi
                        </Link>
                    </div>
                </div>
            </div>
            <div className="hidden md:block bg-amber-brand relative overflow-hidden order-1 md:order-2">
                <div className="bg-grid absolute inset-0 opacity-20"></div>
                <div className="relative z-10 p-12 h-full flex flex-col justify-between text-navy">
                    <Link to="/">
                        <img
                            src="https://customer-assets.emergentagent.com/job_2c1eb65f-a661-481f-98ee-754a9ceda4a7/artifacts/e8s7vgy0_staff.png"
                            alt="Staff Flow 360"
                            className="h-32 w-auto bg-white rounded-md p-2"
                        />
                    </Link>
                    <div>
                        <div className="font-display text-5xl leading-tight mb-4">
                            Pronto a portare
                            <br />
                            <span className="italic">la tua brigata</span> al
                            livello successivo?
                        </div>
                        <p className="text-navy/80 max-w-md">
                            14 giorni di trial gratuito. Nessuna carta
                            richiesta.
                        </p>
                    </div>
                    <div className="text-xs text-navy/60">
                        Staff Flow 360 · un prodotto Makai
                    </div>
                </div>
            </div>
        </div>
    );
}
